/**
 * 统一登录态处理模块
 * 提供：自定义弹窗提示 + 清除登录信息 + 跳转登录页
 * 供 request.js、路由守卫、页面按钮等场景共用
 */
import router from '../router'
import EventBus from './event-bus'

/**
 * 自定义提示弹窗：从顶部滑入 + 遮罩 + 自动关闭跳转
 * @param {string} msg 提示信息
 * @param {number} duration 显示时长(ms)，默认2000
 * @param {number} overlayOpacity 遮罩透明度 0~1，默认0.3
 */
export function showAuthDialog(msg, duration = 2000, overlayOpacity = 0.3) {
  if (document.getElementById('__401-overlay')) return

  // 禁止页面滚动，防止出现滚动条
  document.body.style.overflow = 'hidden'

  // 创建遮罩
  const overlay = document.createElement('div')
  overlay.id = '__401-overlay'
  overlay.style.cssText = `
    position: fixed; top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0,0,0,${overlayOpacity});
    z-index: 9998;
    opacity: 0;
    transition: opacity 0.3s;
  `
  document.body.appendChild(overlay)

  // 创建弹窗
  const dialog = document.createElement('div')
  dialog.id = '__401-dialog'
  dialog.innerHTML = `
    <div class="__401-dialog-icon"><i class="el-icon-warning"></i></div>
    <div class="__401-dialog-msg">${msg || '登录已过期，请重新登录'}</div>
  `
  dialog.style.cssText = `
    position: fixed;
    top: 20%;
    left: 50%;
    transform: translateX(-50%) translateY(-50vh);
    z-index: 9999;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.15);
    padding: 30px 40px 45px;
    text-align: center;
    min-width: 300px;
    transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  `
  document.body.appendChild(dialog)

  // 双重RAF确保浏览器先渲染初始状态，再触发过渡动画
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      overlay.style.opacity = '1'
      dialog.style.transform = 'translateX(-50%) translateY(-50%)'
    })
  })

  // duration后关闭并跳转
  setTimeout(() => {
    dialog.style.transform = 'translateX(-50%) translateY(-50vh)'
    overlay.style.opacity = '0'
    setTimeout(() => {
      dialog.remove()
      overlay.remove()
      document.body.style.overflow = ''
      router.push('/login')
      window.__isAuthRedirecting = false
    }, 400)
  }, duration)
}

/**
 * 清除本地登录信息
 */
export function clearAuth() {
  localStorage.removeItem('token')
  localStorage.removeItem('username')
  localStorage.removeItem('userinfo')
}

/**
 * 统一处理未登录/登录过期逻辑
 * - 清除登录信息
 * - 弹出提示弹窗（silent 模式下跳过）
 * - 自动跳转登录页（silent 模式下跳过）
 * @param {string} msg 提示信息
 * @param {boolean} silent 是否静默模式（只清token+更新UI，不弹窗不跳转）
 */
export function handleAuthExpired(msg, silent = false) {
  if (window.__isAuthRedirecting) return
  clearAuth()
  EventBus.$emit('auth-changed')
  if (silent) return
  window.__isAuthRedirecting = true
  showAuthDialog(msg, 2000, 0.3)
}

/**
 * 检查是否已登录（本地 token 是否存在）
 * @returns {boolean}
 */
export function isLoggedIn() {
  return !!localStorage.getItem('token')
}
